import React, { useState } from 'react';
import { Table, Button, Form, InputGroup, Card, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import dbService from '../../../services/dbService';
import { useAuth } from '../../../context/AuthContext';
import { usePermissions } from '../../../hooks/usePermissions';
import { Trash, PlusCircle } from 'react-bootstrap-icons';

const WatchlistManager = ({ watchlists, onUpdate }) => {
    const [newItem, setNewItem] = useState({ listId: 'un-sanctions', value: '' });
    const { user } = useAuth();
    const { permissions } = usePermissions();

    const handleAddItem = async () => {
        if (!newItem.value.trim()) { toast.error("Entry cannot be empty."); return; }
        
        const listToUpdate = watchlists.find(wl => wl.id === newItem.listId);
        if (listToUpdate) {
            const updatedList = { ...listToUpdate, entries: [...listToUpdate.entries, { name: newItem.value, nationality: 'N/A', dob: null }] };
            // A simplified entry for this prototype
            
            await dbService.update('watchlists', updatedList);
            toast.success(`Added "${newItem.value}" to ${listToUpdate.name}.`);
            dbService.addLog({ user: user.name, action: 'Watchlist Updated', details: `Added entry to ${listToUpdate.name}` });
            setNewItem({ listId: newItem.listId, value: '' });
            onUpdate(); // Tell the parent to re-fetch data
        }
    };

    const handleRemoveItem = async (listId, itemIndex) => {
        const listToUpdate = watchlists.find(wl => wl.id === listId);
        if (listToUpdate) {
            const updatedEntries = listToUpdate.entries.filter((_, index) => index !== itemIndex);
            const updatedList = { ...listToUpdate, entries: updatedEntries };

            await dbService.update('watchlists', updatedList);
            toast.warn(`Removed entry from ${listToUpdate.name}.`);
            dbService.addLog({ user: user.name, action: 'Watchlist Updated', details: `Removed entry from ${listToUpdate.name}` });
            onUpdate();
        }
    };

    return (
        <div>
            <p>Manage the sanction lists and keyword lists used by the screening engine. (Admin only)</p>
            {permissions.isAdmin && (
                <Card className="mb-4">
                    <Card.Body>
                        <InputGroup>
                            <Form.Select value={newItem.listId} onChange={e => setNewItem({...newItem, listId: e.target.value})}>
                                {watchlists.map(wl => <option key={wl.id} value={wl.id}>{wl.name}</option>)}
                            </Form.Select>
                            <Form.Control placeholder="New entity or keyword..." value={newItem.value} onChange={e => setNewItem({...newItem, value: e.target.value})} />
                            <Button onClick={handleAddItem}><PlusCircle /></Button>
                        </InputGroup>
                    </Card.Body>
                </Card>
            )}

            <Row>
                {watchlists.map(list => (
                    <Col md={6} key={list.id} className="mb-3">
                        <Card>
                            <Card.Header>{list.name} ({list.type})</Card.Header>
                            <Card.Body style={{maxHeight: '300px', overflowY: 'auto'}}>
                                <Table striped size="sm">
                                    <tbody>
                                        {list.entries.map((item, index) => (
                                            <tr key={index}>
                                                <td>{typeof item === 'object' ? item.name : item}</td>
                                                {permissions.isAdmin && <td className="text-end"><Button variant="outline-danger" size="sm" onClick={() => handleRemoveItem(list.id, index)}><Trash /></Button></td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default WatchlistManager;